import { Fragment } from 'react';
import { Col, Form, FormGroup, Label, Input, Row, Card, CardBody } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { Btn } from '../../../AbstractElements';
import { setField } from '../../../Features/Learning/CategoryProgram/addCategoryProgramSlice';

const CategoryProgramForm = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.addCategoryProgram);

  const handleChanges = (e) => {
    const { name, value } = e.target;
    dispatch(setField({ field: name, value }));
  };

  const handleAddPoint = () => {
    const updatedPoints = [...(data?.children || [])];
    updatedPoints.push({ name: '', slug: '', parent_id: 1 });
    dispatch(setField({ field: 'children', value: updatedPoints }));
  };

  const handleRemovePoint = (index) => {
    const updatedPoints = [...(data?.children || [])];
    updatedPoints.splice(index, 1);
    dispatch(setField({ field: 'children', value: updatedPoints }));
  };

  const handleChangePoint = (e, index) => {
    const { name, value } = e.target;
    const newPointTemp = [...(data?.children || [])];
    newPointTemp[index] = { ...newPointTemp[index], [name]: value };
    dispatch(setField({ field: 'children', value: newPointTemp }));
  };

  return (
    <Fragment>
      <Form className="row needs-validation category-program-form" noValidate>
        <Col sm="12">
          <div className="category-program-form__section">
            <h6 className="category-program-form__section-title">Kategori Induk</h6>
            <Row>
              <Col md="6">
                <FormGroup className="mb-3">
                  <Label for="cp-name" className="category-program-form__label">
                    Nama Kategori
                  </Label>
                  <Input
                    className="form-control"
                    id="cp-name"
                    type="text"
                    name="name"
                    placeholder="Contoh: Tryout SKD"
                    required
                    value={data?.name || ''}
                    onChange={handleChanges}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup className="mb-3">
                  <Label for="cp-slug" className="category-program-form__label">
                    Slug Kategori
                  </Label>
                  <Input
                    className="form-control"
                    id="cp-slug"
                    type="text"
                    name="slug"
                    placeholder="contoh: tryout-skd"
                    required
                    value={data?.slug || ''}
                    onChange={handleChanges}
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>

          <div className="category-program-form__section">
            <div className="category-program-form__section-head">
              <h6 className="category-program-form__section-title mb-0">Sub Kategori</h6>
              <Btn
                attrBtn={{
                  color: 'primary',
                  outline: true,
                  size: 'sm',
                  type: 'button',
                  onClick: handleAddPoint,
                }}
              >
                <i className="fa fa-plus me-1" aria-hidden="true" />
                Tambah sub
              </Btn>
            </div>

            {(data?.children || []).length === 0 && (
              <p className="text-muted small mb-3">Belum ada sub-kategori. Tambahkan minimal satu bila diperlukan.</p>
            )}

            {(data?.children || []).map((point, index) => (
              <Card key={`sub-${index}`} className="category-program-form__subcard mb-3">
                <CardBody className="py-3">
                  <div className="category-program-form__subcard-head">
                    <span className="category-program-form__sub-index">Sub {index + 1}</span>
                    {index > 0 && (
                      <button
                        type="button"
                        className="category-program__icon-btn category-program__icon-btn--danger"
                        title="Hapus sub-kategori"
                        aria-label={`Hapus sub kategori ${index + 1}`}
                        onClick={() => handleRemovePoint(index)}
                      >
                        <i className="fa fa-trash-o" aria-hidden="true" />
                      </button>
                    )}
                  </div>
                  <Row>
                    <Col md="6">
                      <FormGroup className="mb-md-0 mb-3">
                        <Label for={`cp-sub-name-${index}`} className="category-program-form__label">
                          Nama
                        </Label>
                        <Input
                          className="form-control"
                          id={`cp-sub-name-${index}`}
                          type="text"
                          name="name"
                          placeholder="Masukkan sub kategori..."
                          required
                          value={point?.name || ''}
                          onChange={(e) => handleChangePoint(e, index)}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-0">
                        <Label for={`cp-sub-slug-${index}`} className="category-program-form__label">
                          Slug
                        </Label>
                        <Input
                          className="form-control"
                          id={`cp-sub-slug-${index}`}
                          type="text"
                          name="slug"
                          placeholder="Masukkan slug..."
                          required
                          value={point?.slug || ''}
                          onChange={(e) => handleChangePoint(e, index)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))}
          </div>
        </Col>
      </Form>
    </Fragment>
  );
};

export default CategoryProgramForm;
